import { cn } from "@/lib/utils";

/** The recording dot: red, pulsing while it records, still while paused. */
export function RecordingDot({ paused = false, className }: { paused?: boolean; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn("size-2.5 shrink-0 rounded-full bg-destructive", !paused && "motion-safe:animate-pulse", className)}
    />
  );
}
